<template>
	<div
		class="flex min-h-screen bg-canvas dark:bg-dark-800 font-sans transition-colors duration-300">
		<!-- Desktop Sidebar -->
		<SideBar class="hidden md:flex" />

		<!-- Mobile Sidebar -->
		<transition name="slide">
			<SideBar
				v-if="isSidebarVisible"
				class="fixed z-50 inset-y-0 left-0 md:hidden" />
		</transition>

		<!-- Mobile overlay -->
		<div
			v-if="isSidebarVisible"
			class="fixed inset-0 bg-black/50 z-40 md:hidden backdrop-blur-sm"
			@click="toggleSidebar" />

		<!-- Main -->
		<div class="flex-1 flex flex-col min-w-0 min-h-screen">
			<HeaderBar @toggleSidebar="toggleSidebar" />

			<main class="flex-1 relative px-7 py-8 overflow-hidden">

				<!-- ── Imigongo: top-left diamond grid ── -->
				<svg
					class="absolute -top-6 -left-6 w-52 h-52 opacity-[0.07] dark:opacity-[0.11] pointer-events-none z-0"
					viewBox="0 0 160 160"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true">
					<g fill="currentColor" class="text-primary-700 dark:text-primary-400">
						<rect x="40"  y="0"   width="28" height="28" transform="rotate(45 40 0)"   />
						<rect x="80"  y="0"   width="28" height="28" transform="rotate(45 80 0)"   />
						<rect x="120" y="0"   width="28" height="28" transform="rotate(45 120 0)"  />
						<rect x="20"  y="40"  width="28" height="28" transform="rotate(45 20 40)"  />
						<rect x="60"  y="40"  width="28" height="28" transform="rotate(45 60 40)"  />
						<rect x="100" y="40"  width="28" height="28" transform="rotate(45 100 40)" />
						<rect x="140" y="40"  width="28" height="28" transform="rotate(45 140 40)" />
						<rect x="40"  y="80"  width="28" height="28" transform="rotate(45 40 80)"  />
						<rect x="80"  y="80"  width="28" height="28" transform="rotate(45 80 80)"  />
						<rect x="120" y="80"  width="28" height="28" transform="rotate(45 120 80)" />
						<rect x="20"  y="120" width="20" height="20" transform="rotate(45 20 120)" />
						<rect x="60"  y="120" width="20" height="20" transform="rotate(45 60 120)" />
						<rect x="100" y="120" width="20" height="20" transform="rotate(45 100 120)"/>
						<rect x="140" y="120" width="20" height="20" transform="rotate(45 140 120)"/>
					</g>
				</svg>

				<!-- ── Imigongo: bottom-right diamond grid ── -->
				<svg
					class="absolute -bottom-6 -right-6 w-48 h-48 opacity-[0.07] dark:opacity-[0.11] pointer-events-none z-0"
					viewBox="0 0 160 160"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true">
					<g fill="currentColor" class="text-primary-700 dark:text-primary-400">
						<rect x="40"  y="0"   width="28" height="28" transform="rotate(45 40 0)"   />
						<rect x="80"  y="0"   width="28" height="28" transform="rotate(45 80 0)"   />
						<rect x="120" y="0"   width="28" height="28" transform="rotate(45 120 0)"  />
						<rect x="20"  y="40"  width="28" height="28" transform="rotate(45 20 40)"  />
						<rect x="60"  y="40"  width="28" height="28" transform="rotate(45 60 40)"  />
						<rect x="100" y="40"  width="28" height="28" transform="rotate(45 100 40)" />
						<rect x="140" y="40"  width="28" height="28" transform="rotate(45 140 40)" />
						<rect x="40"  y="80"  width="28" height="28" transform="rotate(45 40 80)"  />
						<rect x="80"  y="80"  width="28" height="28" transform="rotate(45 80 80)"  />
						<rect x="120" y="80"  width="28" height="28" transform="rotate(45 120 80)" />
						<rect x="20"  y="120" width="20" height="20" transform="rotate(45 20 120)" />
						<rect x="60"  y="120" width="20" height="20" transform="rotate(45 60 120)" />
						<rect x="100" y="120" width="20" height="20" transform="rotate(45 100 120)"/>
						<rect x="140" y="120" width="20" height="20" transform="rotate(45 140 120)"/>
					</g>
				</svg>

				<!-- ── Imigongo: mid-right chevron strip ── -->
				<svg
					class="absolute top-1/4 -right-2 w-12 h-44 opacity-[0.05] dark:opacity-[0.08] pointer-events-none z-0"
					viewBox="0 0 60 180"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true">
					<g fill="currentColor" class="text-primary-700 dark:text-primary-400">
						<polygon points="0,0   60,0   30,30"  />
						<polygon points="0,40  60,40  30,70"  />
						<polygon points="0,80  60,80  30,110" />
						<polygon points="0,120 60,120 30,150" />
					</g>
				</svg>

				<!-- ── Imigongo: nested concentric diamonds (mid-left) ── -->
				<svg
					class="absolute top-1/2 -left-8 -translate-y-1/2 w-28 h-28 opacity-[0.05] dark:opacity-[0.08] pointer-events-none z-0"
					viewBox="0 0 120 120"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true">
					<g stroke="currentColor" stroke-width="3" fill="none"
class="text-primary-700 dark:text-primary-400">
						<rect x="60" y="10" width="64" height="64" transform="rotate(45 60 10)" />
						<rect x="60" y="22" width="46" height="46" transform="rotate(45 60 22)" />
						<rect x="60" y="34" width="28" height="28" transform="rotate(45 60 34)" />
						<rect x="60" y="46" width="10" height="10" transform="rotate(45 60 46)" />
					</g>
				</svg>

				<div class="relative z-10">
					<router-view />
				</div>
			</main>

			<!-- Footer -->
			<footer
				class="bg-surface dark:bg-dark-700 border-t border-primary-100 dark:border-dark-600 px-7 py-4 flex items-center justify-between transition-colors duration-300 relative overflow-hidden">

				<!-- ── Imigongo: small diamond row behind footer text ── -->
				<svg
					class="absolute bottom-3 left-1/2 -translate-x-1/2 w-56 h-8 opacity-[0.07] dark:opacity-[0.1] pointer-events-none"
					viewBox="0 0 220 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true">
					<g fill="currentColor" class="text-primary-700 dark:text-primary-400">
						<rect x="18"  y="14" width="18" height="18" transform="rotate(45 18 14)"  />
						<rect x="58"  y="14" width="18" height="18" transform="rotate(45 58 14)"  />
						<rect x="98"  y="14" width="18" height="18" transform="rotate(45 98 14)"  />
						<rect x="138" y="14" width="18" height="18" transform="rotate(45 138 14)" />
						<rect x="178" y="14" width="18" height="18" transform="rotate(45 178 14)" />
					</g>
				</svg>

				<span
					class="font-display text-[15px] font-extrabold text-primary-600 dark:text-primary-400 relative z-10">
					Trekko
				</span>
				<span class="text-[12px] text-muted dark:text-muted-light relative z-10">
					© {{ currentYear }} All rights reserved.
				</span>
			</footer>
		</div>

		<!-- ── Onboarding Guide overlay ── -->
		<OnboardingGuide />
	</div>
</template>

<script>
import SideBar from "@/components/SideBar.vue";
import HeaderBar from "@/components/HeaderBar.vue";
import OnboardingGuide from "@/components/OnboardingGuide.vue";
import { useTheme } from "@/composables/useTheme";

export default {
	components: { SideBar, HeaderBar, OnboardingGuide },

	setup() {
		const { isDark } = useTheme();
		return { isDark };
	},

	data() {
		return {
			isSidebarVisible: false,
		};
	},

	computed: {
		currentYear() {
			return new Date().getFullYear();
		},
	},

	methods: {
		toggleSidebar() {
			this.isSidebarVisible = !this.isSidebarVisible;
		},
	},
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-enter-from,
.slide-leave-to {
	transform: translateX(-100%);
}
.slide-enter-to,
.slide-leave-from {
	transform: translateX(0);
}
</style>